module.exports = __webpack_public_path__ + "img/fishing.e1b25d46.png";